// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ClearBtn_clear-btn__qfXBW {
  display: flex;
  align-items: center;
  gap: 0.7rem;
  font-size: var(--text-base);
}

.ClearBtn_clear-btn__icon__k-yje {
  width: 2rem;
  height: 2rem;
  object-fit: contain;
}
`, "",{"version":3,"sources":["webpack://./src/components/UI/ClearBtn/ClearBtn.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":[".clear-btn {\n  display: flex;\n  align-items: center;\n  gap: 0.7rem;\n  font-size: var(--text-base);\n}\n\n.clear-btn__icon {\n  width: 2rem;\n  height: 2rem;\n  object-fit: contain;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"clear-btn": `ClearBtn_clear-btn__qfXBW`,
	"clear-btn__icon": `ClearBtn_clear-btn__icon__k-yje`
};
export default ___CSS_LOADER_EXPORT___;
